import { Grid } from '@material-ui/core';
import React, { useMemo } from 'react';
import ReportGijgoGrid from '../ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../Core/Grid/inputFormatter';

const PartsList = (props) => {
    const baseColumns = [
        { field: 'reference', sortable: false, title: `REFERENCE`, filterable: false, width: 120 },
        { field: 'partDescription', sortable: true, title: `DESCRIPTION`, showColumnTotal: true, filterable: false, width: 200 },
        {
            field: 'netValue',
            sortable: true,
            title: `NET PRICE`,
            showColumnTotal: true,
            align: 'right',
            filterable: false,
            width: 60,
            renderer: (val, record) => {
                return record.netValue !== undefined ? formatters.CurrencyThousandSeparator(+record.netValue) : '';
            }
        },
        {
            field: 'discPerc',
            sortable: true,
            title: `DISC %`,
            showColumnTotal: true,
            align: 'right',
            filterable: false,
            width: 60,
            renderer: (val, record) => {
                return record.discPerc !== undefined ? formatters.ToFixedSeparator(+record.discPerc) : '';
            }
        },
        {
            field: 'discValue',
            sortable: true,
            title: `DISC PRICE`,
            showColumnTotal: true,
            align: 'right',
            filterable: false,
            width: 60,
            renderer: (val, record) => {
                return record.discValue !== undefined ? formatters.CurrencyThousandSeparator(+record.discValue) : '';
            }
        },
        { field: 'bin', sortable: true, title: `BIN`, showColumnTotal: true, align: 'right', filterable: false, width: 60 },
        { field: 'askQuantity', sortable: true, title: 'ASK QTY ', showColumnTotal: true, align: 'right', filterable: false, width: 60 },
        { field: 'servedQuantity', sortable: true, title: 'SRV Q', showColumnTotal: true, align: 'right', filterable: false, width: 60 },
        { field: 'reserveQty', title: 'Q RES', showColumnTotal: true, align: 'right', filterable: false, sortable: false, width: 60 },
        { field: 'unallocatedTotal1', title: 'Q ORD', showColumnTotal: true, align: 'right', filterable: false, sortable: false, width: 60 },
        { field: 'rwi', title: 'RWI', showColumnTotal: true, align: 'right', filterable: false, sortable: false, width: 60 },
        {
            field: 'customerPrice',
            title: 'CUST NET AMT',
            showColumnTotal: true,
            align: 'right',
            filterable: false,
            sortable: false,
            width: 80,
            renderer: (val, record) => {
                return record.customerPrice !== undefined ? formatters.CurrencyThousandSeparator(+record.customerPrice) : '';
            }
        }
        // { field: 'codeImputation', title: 'Corrective.', showColumnTotal: true, align: 'right', filterable: false, sortable: false, width: 100 }
    ];

    return (
        <Grid item container spacing={1} xs={12}>
            <Grid item xs={12}>
                <ReportGijgoGrid
                    // dataConverter={(res) => ({
                    //     records: props.List,
                    //     total: props.List.length
                    // })}
                    localRowsData={props.List}
                    columns={baseColumns}
                    hidePagination={true}
                    hideFilterRow={true}
                />
            </Grid>
        </Grid>
    );
};

export default PartsList;
